import { render, staticRenderFns } from "./Opz2Metrics.vue?vue&type=template&id=38a44765&scoped=true"
import script from "./Opz2Metrics.vue?vue&type=script&lang=ts"
export * from "./Opz2Metrics.vue?vue&type=script&lang=ts"
import style0 from "./Opz2Metrics.vue?vue&type=style&index=0&id=38a44765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a44765",
  null
  
)

export default component.exports